module.exports = __webpack_public_path__ + "img/default_pic_16_9.fe942fe6.png";